import React, { useEffect, useState } from "react";
import { $getSelection, $isRangeSelection, FORMAT_TEXT_COMMAND } from "lexical";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";

// mui
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';

// icons
import FormatBoldIcon from '@mui/icons-material/FormatBold';
import FormatItalicIcon from '@mui/icons-material/FormatItalic';
import FormatUnderlinedIcon from '@mui/icons-material/FormatUnderlined';
import StrikethroughSIcon from '@mui/icons-material/StrikethroughS';

const InlineStyleButtons = () => {
    const [editor] = useLexicalComposerContext();

    const [isBold, setIsBold] = useState(false);
    const [isItalic, setIsItalic] = useState(false);
    const [isUnderline, setIsUnderline] = useState(false);
    const [isStrikethrough, setIsStrikethrough] = useState(false);

    useEffect(() => {
        editor.registerUpdateListener(({ editorState }) => {
            editorState.read(() => {
                const selection = $getSelection();

                if (!$isRangeSelection(selection)) return;

                setIsBold(selection.hasFormat("bold"));
                setIsItalic(selection.hasFormat("italic"));
                setIsUnderline(selection.hasFormat("underline"));
                setIsStrikethrough(selection.hasFormat("strikethrough"));
            });
        });
    }, [editor]);

    return (
        <ButtonGroup
            size="small"
            aria-label="small button group"
            sx={{
                [`& .MuiButtonBase-root`]: {
                    borderColor: (theme) => theme.palette.grey[400],
                    color: (theme) => theme.palette.grey[600],
                },
                [`& .MuiSvgIcon-root`]: {
                    fontSize: 18,
                },
            }}
        >
            <Button
                type="button"
                aria-label="format bold"
                role="checkbox"
                onClick={() => editor.dispatchCommand(FORMAT_TEXT_COMMAND, "bold")}
                className={isBold ? 'active' : ''}
            >
                {<FormatBoldIcon />}
            </Button>
            <Button
                type="button"
                aria-label="format italic"
                role="checkbox"
                onClick={() => editor.dispatchCommand(FORMAT_TEXT_COMMAND, "italic")}
                className={isItalic ? 'active' : ''}
            >
                {<FormatItalicIcon />}
            </Button>
            <Button
                type="button"
                aria-label="format underline"
                role="checkbox"
                onClick={() => editor.dispatchCommand(FORMAT_TEXT_COMMAND, "underline")}
                className={isUnderline ? 'active' : ''}
           >
                {<FormatUnderlinedIcon />}
            </Button>
            <Button
                type="button"
                aria-label="format strikethrough"
                role="checkbox"
                onClick={() => editor.dispatchCommand(FORMAT_TEXT_COMMAND, "strikethrough")}
                className={isStrikethrough ? 'active' : ''}
            >
                {<StrikethroughSIcon />}
            </Button>
        </ButtonGroup>
    );
};

export default InlineStyleButtons;
